
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14.3","height":"26.5","viewBox":"0 0 14.3 26.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.8 0h-3.4C6.5 0 4 2.6 4 6.5v3H.5c-.3 0-.5.3-.5.6v4.4c0 .2.2.5.5.5H4v11c0 .3.2.5.5.5H9c.3 0 .5-.2.5-.5V15h4c.3 0 .5-.2.5-.5v-4.4c0-.3-.2-.5-.5-.5h-4V7c0-1.2.3-1.8 1.9-1.8h2.3c.3 0 .5-.2.5-.5v-4c.1-.5-.1-.7-.4-.7z"}})])
          )
        }
      }
    